import { GoogleMapViewer } from '@findy-code/yuffie/shared/google-map-viewer';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';
import Link from 'next/link';
import { FaLink, FaMapMarkerAlt, FaUserFriends } from 'react-icons/fa';

import styles from './company-detail-summary.component.module.scss';
import { SectionLayout } from './section-layout.component';
type Props = {
  name: string;
  description: string;
  url: string;
  location: string;
  employeeCount?: number | null;
};

export const CompanyDetailSummary = ({
  name,
  location,
  description,
  url,
  employeeCount,
}: Props) => {
  const roundedEmployeeCount = employeeCount
    ? Math.ceil(employeeCount / 10) * 10
    : null;

  return (
    <SectionLayout heading={{ title: '会社概要' }} id="summary">
      <Stack direction={{ base: 'column', md: 'row' }} spacing={32}>
        <Stack className={styles.summaryWrap} spacing={{ base: 8, md: 16 }}>
          <Stack spacing={{ base: 8, md: 16 }}>
            <Text
              className={styles.companyName}
              font={{ base: 'heading-m', md: 'heading-l' }}
            >
              {name}
            </Text>
            <Text className={styles.companyDescription} font="body-s">
              {description}
            </Text>
          </Stack>
          <Stack spacing="s">
            {!!location && (
              <p className={styles.companyLocation}>
                <span aria-label="住所">
                  <FaMapMarkerAlt
                    aria-hidden
                    color="#636B71"
                    height={20}
                    width={20}
                  />
                </span>
                {location}
              </p>
            )}
            {!!url && (
              <p className={styles.companyUrl}>
                <span aria-label="企業URL">
                  <FaLink aria-hidden color="#636B71" height={20} width={20} />
                </span>
                <Link href={url}>{url}</Link>
              </p>
            )}
            {!!roundedEmployeeCount && (
              <p className={styles.companyEmployCount}>
                <span aria-label="従業員数" role="img">
                  <FaUserFriends
                    aria-hidden
                    color="#636B71"
                    height={20}
                    width={20}
                  />
                </span>
                {roundedEmployeeCount}人程度
              </p>
            )}
          </Stack>
        </Stack>
        {!!location && (
          <div className={styles.mapWrap}>
            <GoogleMapViewer fullSize location={location} />
          </div>
        )}
      </Stack>
    </SectionLayout>
  );
};
